<template>
    <fragment for="subject in subjects">
        <fragment v-for="subject in subjects" :key="subject._uid">
            <insurer-headers v-if="subject.type === 'insurer'" />
            <indemnity-headers v-if="subject.type === 'indemnity'" />
            <rates-headers v-if="subject.type === 'rates'" />
        </fragment>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import InsurerHeaders from "./subject-headers-by-types/InsurerHeaders.vue";
import IndemnityHeaders from "./subject-headers-by-types/IndemnityHeaders.vue";
import RatesHeaders from "./subject-headers-by-types/RatesHeaders.vue";

export default {
    components: { Fragment, InsurerHeaders, IndemnityHeaders, RatesHeaders },
    props: ["subjects"],
};
</script>

<style scoped lang="sass">
</style>